import { motion, useTransform } from "framer-motion";

const ICONS = [
  { src: "/icons/clapper.webp", cls: "left-[4%] top-[20%] w-[11vw] max-w-[190px]", rot: -10, speed: -90, delay: 0.9, float: 0 },
  { src: "/icons/timeline.webp", cls: "left-[13%] bottom-[10%] w-[12vw] max-w-[210px]", rot: 6, speed: -50, delay: 1.1, float: 1.2 },
  { src: "/icons/waveform.webp", cls: "left-[22%] top-[8%] w-[9vw] max-w-[150px]", rot: 8, speed: -130, delay: 1.3, float: 0.6 },
  { src: "/icons/play.webp", cls: "right-[4%] top-[16%] w-[11vw] max-w-[190px]", rot: 9, speed: -80, delay: 1.0, float: 0.9 },
  { src: "/icons/colorwheel.webp", cls: "right-[12%] bottom-[10%] w-[12vw] max-w-[210px]", rot: -7, speed: -60, delay: 1.2, float: 0.3 },
  { src: "/icons/captions.webp", cls: "right-[23%] top-[6%] w-[9vw] max-w-[150px]", rot: -12, speed: -120, delay: 1.4, float: 1.5 },
];

const Icon = ({ icon, progress }) => {
  const y = useTransform(progress, [0, 1], [0, icon.speed]);
  return (
    <motion.div style={{ y }} className={`absolute ${icon.cls}`}>
      <motion.div
        initial={{ opacity: 0, y: 40, rotate: icon.rot * 1.8, scale: 0.7 }}
        animate={{ opacity: 1, y: 0, rotate: icon.rot, scale: 1 }}
        transition={{ duration: 1.2, delay: icon.delay, ease: [0.16, 1, 0.3, 1] }}
      >
        <motion.img
          src={icon.src}
          alt=""
          loading="eager"
          animate={{ y: [0, -14, 0], rotate: [0, icon.rot > 0 ? 3 : -3, 0] }}
          transition={{ duration: 6 + icon.float, repeat: Infinity, ease: "easeInOut", delay: icon.float }}
          className="w-full h-auto drop-shadow-[0_30px_50px_rgba(200,240,49,0.12)]"
        />
      </motion.div>
    </motion.div>
  );
};

export const HeroCards = ({ progress }) => (
  <div aria-hidden="true" data-testid="hero-icons" className="hidden md:block absolute inset-0 pointer-events-none">
    {ICONS.map((c) => (
      <Icon key={c.src} icon={c} progress={progress} />
    ))}
  </div>
);

export const HeroCardsMobile = () => (
  <motion.div
    data-testid="hero-icons-mobile"
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, delay: 1.0, ease: [0.16, 1, 0.3, 1] }}
    className="md:hidden mt-12 flex items-center justify-center gap-1"
  >
    {ICONS.slice(0, 4).map((c, i) => (
      <motion.img
        key={c.src}
        src={c.src}
        alt=""
        animate={{ y: [0, -6, 0] }}
        transition={{ duration: 4 + i * 0.6, repeat: Infinity, ease: "easeInOut", delay: i * 0.4 }}
        style={{ rotate: `${c.rot / 2}deg` }}
        className={`${i % 2 ? "w-[24vw]" : "w-[20vw] -mt-4"}`}
      />
    ))}
  </motion.div>
);

export default HeroCards;
